import type { TrackedTask } from "./TrackedTask"

export type TrackingCallback = (task: Omit<TrackedTask, "enum">) => void
